import icon_68 from '../../../assets/customIcons/Raggruppa_68.svg';
import icon_70 from '../../../assets/customIcons/Raggruppa_70.svg';
import icon_71 from '../../../assets/customIcons/Raggruppa_71.svg';
import icon_72 from '../../../assets/customIcons/Raggruppa_72.svg';
import icon_73 from '../../../assets/customIcons/Raggruppa_73.svg';
import icon_74 from '../../../assets/customIcons/Raggruppa_74.svg';
import icon_75 from '../../../assets/customIcons/Raggruppa_75.svg';
import icon_76 from '../../../assets/customIcons/Raggruppa_76.svg';

// Nel contenuto si salva la chiave (stabile), non l'URL con hash generato da webpack
export const icons = {
  icon_68,
  icon_70,
  icon_71,
  icon_72,
  icon_73,
  icon_74,
  icon_75,
  icon_76,
};

export const iconChoices = [
  ['icon_68', 'icona 1'],
  ['icon_70', 'icona 2'],
  ['icon_71', 'icona 3'],
  ['icon_72', 'icona 4'],
  ['icon_73', 'icona 5'],
  ['icon_74', 'icona 6'],
  ['icon_75', 'icona 7'],
  ['icon_76', 'icona 8'],
];

// Retrocompatibilità: i vecchi blocchi salvavano direttamente l'URL del file
export const resolveIcon = (value) => icons[value] ?? value;
